// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"8":"de65ee62","372":"dd35c0d6","629":"3a141ae5","637":"24984cb3","797":"c6000122","891":"f4ecfd44"}[chunkId] + ".css";
};